import { render, staticRenderFns } from "./Resourcest.vue?vue&type=template&id=ed204d42&scoped=true&"
import script from "./Resourcest.vue?vue&type=script&lang=js&"
export * from "./Resourcest.vue?vue&type=script&lang=js&"
import style0 from "./Resourcest.vue?vue&type=style&index=0&id=ed204d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed204d42",
  null
  
)

export default component.exports